'use client'

import { NextSeo } from 'next-seo'
import { IGenericSEOModel } from 'types/contentful/genericSEOModel'
import { Asset } from 'contentful'
import { useEffect, useState } from 'react'
import { getAbsoluteUrl } from '@utils/getAbsoluteUrl'
import { usePathname } from 'next/navigation'

export function SeoMetaData({
  seoMetaTags,
  fallbackTitle,
  fallbackDescription,
  fallbackImages,
}: {
  seoMetaTags: IGenericSEOModel
  fallbackTitle?: string
  fallbackDescription?: string
  fallbackImages?: Asset[]
}) {
  const [pageUrl, setPageUrl] = useState<string>('')
  const pathname = usePathname()

  useEffect(() => {
    setPageUrl(
      getAbsoluteUrl({
        basePath: process.env.NEXT_PUBLIC_DOMAIN_NAME,
        path: pathname,
      })
    )
  }, [])

  return (
    <NextSeo
      title={seoMetaTags?.seoTitle || fallbackTitle}
      description={seoMetaTags?.seoDescription || fallbackDescription}
      openGraph={{
        type: seoMetaTags?.ogType || 'website',
        url: seoMetaTags?.ogUrl || pageUrl,
        title: seoMetaTags?.seoTitle || fallbackTitle,
        description: seoMetaTags?.seoDescription || fallbackDescription,
        locale: seoMetaTags?.ogLocale || 'en_US',
        site_name: seoMetaTags?.ogSitename || 'noissue',
        images: seoMetaTags?.ogImage?.length
          ? seoMetaTags?.ogImage?.map((image) => ({
              url: image?.fields?.file?.url,
              width: 150,
              alt:
                image?.fields?.title || seoMetaTags?.seoTitle || fallbackTitle,
            }))
          : fallbackImages?.map((image) => ({
              url: image?.fields?.file?.url,
              width: 150,
              alt:
                image?.fields?.title || seoMetaTags?.seoTitle || fallbackTitle,
            })),
      }}
      twitter={{
        cardType: seoMetaTags?.twitterCard,
        site: seoMetaTags?.twitterSite,
        handle: seoMetaTags?.twitterCreator,
      }}
    />
  )
}
